export enum HeatingSystem {
  RADIATORI = 'RADIATORI',
  PAVIMENTO = 'PAVIMENTO',
  ARIA = 'ARIA',
  STUFA = 'STUFA',
}
